import { call, fork, select, put, takeEvery } from 'redux-saga/effects';

import { fetchAddres } from '../api';

import { addressActions } from './actions';
import { getAddressById, getCurrentAddress } from './selectors';

export function* loadAddress({payload}) {
  const { addressId, filters } = payload;

  const address = yield select(getAddressById, addressId);

  if ( address && address.isNew ) {
    yield call(fetchAddres, addressId, filters);
  }
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadAddress() {
  yield takeEvery(addressActions.LOAD_ADDRESS, loadAddress);
}

//=====================================
//  ROOT
//-------------------------------------

export const addressSagas = [
  fork(watchLoadAddress),
];
